import React, { useEffect } from 'react';
import { useAuth } from '../../context/AuthProvider';
import Loader from '../common/Loader';

const SecureRoute = ({ children }) => {
  const { authState, login } = useAuth();

  useEffect(() => {
    // If user is not authenticated and we're not in the process of checking,
    // redirect to Okta login
    if (!authState.isAuthenticated && !authState.isLoading) {
      login();
    }
  }, [authState.isAuthenticated, authState.isLoading, login]);

  if (authState.isLoading) {
    return <Loader />;
  }

  if (authState.isAuthenticated) {
    return children;
  }

  return <Loader />;
};

export default SecureRoute;